package com.starparty.app.vector_maths

import kotlin.math.*

open class Point2d : Tuple2d {
    constructor(x: Double, y: Double) : super(x, y) {}
    constructor(p: DoubleArray) : super(p) {}
    constructor(p1: Point2d) : super(p1) {}
    constructor(t1: Tuple2d) : super(t1) {}
    constructor() {}

    fun distanceSquared(p1: Point2d): Double {
        val dx = x - p1.x
        val dy = y - p1.y
        return dx * dx + dy * dy
    }

    fun distance(p1: Point2d): Double {
        val dx = x - p1.x
        val dy = y - p1.y
        return sqrt(dx * dx + dy * dy)
    }

    fun distanceL1(p1: Point2d): Double {
        return abs(x - p1.x) + abs(y - p1.y)
    }

    fun distanceLinf(p1: Point2d): Double {
        return max(
            abs(x - p1.x),
            abs(y - p1.y)
        )
    }
}